import { useEffect, useMemo, useRef, useState } from "react";
import ReportsPagesContent from "src/component/ReportsPagesContent";
import SearchWrapper from "src/component/searchSection";
import { GetDecisionsForManualReceive } from "src/requests/ManualRequests";
import { useTranslation } from "react-i18next";
import { checkIfSelectedPharmacy, dateFormatter, errorToaster, getMonthNumber, handleDate } from "src/utils";
import { Original } from "src/common/Common.Type";
// import usePrint from "src/hooks/usePrint";
import { GetRequestForPrint } from "src/requests/Shared";
import { useGet } from "src/hooks/useGet";
import { RowAction } from "src/component/RequestRowAction/inde";
import PrintContentWrapper from "src/component/PrintContentWrapper/PrintContentWrapper";
import PrintableRequestTable from "src/component/PrintedPDF/PrintRequestTable/PrintableRequestTable";
import MedicinesPopup from "./MedicinesPopup";
import { usePrintImages } from "src/hooks/usePrintImages";
import { BOOLEAN_COLOR_MAP, DecisionTypes, STATUS_COLOR_MAP } from "src/common/constants";
import { PatientData } from "src/types/patientData";
import Status from "src/component/Status/Status";
import BaseBtn from "src/component/ActionBtn/BaseBtn";
import BatchDispensePopup from "src/component/popup/BatchDispensePopup/BatchDispensePopup";
import { useLocation } from "react-router-dom";




const ManualReceive = () => {

    const { t } = useTranslation()


    const [selectedPrintRequestId, setSelectedPrintRequestId] = useState<number | null>(null)
    const [isModel56, setIsModel56] = useState<boolean | null>(null)

    const [remainingAmount, setRemainingAmount] = useState(0)
    const [mothlyAmount, setMothlyAmount] = useState(0)
    const [decisionId, setDecisionId] = useState<number | null>(null)

    const [recordID, setRecordID] = useState<number | null>(null)
    const [hospitalID, setHospitalID] = useState<number | null>(null)

    const [patientData, setPatientData] = useState<PatientData | null>(null)
    const [requestIdToViewBatches, setRequestIdToViewBatches] = useState<number | null>(null)

    const { data: requestRow, setData } = useGet({ API: GetRequestForPrint, depArr: [selectedPrintRequestId], isNotValid: !selectedPrintRequestId, params: [selectedPrintRequestId], defaultValue: null })

    const modelpopup = useRef<any>("")


    const printRequestMedicines = useRef<HTMLElement | null>(null);
    const printRequestIsNeedCoolingMedicines = useRef<HTMLElement | null>(null);
    const batchDispensePopupRef = useRef<HTMLDivElement>(null);

    const { state } = useLocation()
    const { handlePrint } = usePrintImages({ title: "request-print" })
    const columns = useMemo(() => [

        {
            Header: "requestId",
            accessor: "requestId",
            Cell: ({ row }: any) => RowAction(row, (ObjectData: any) =>
                ShowAccordion(ObjectData.request.id, ObjectData.hospitalId, row?.original?.remainingAmount, row?.original?.monthlyAmount, ObjectData?.id, {
                    name: ObjectData?.patientName,
                    nationalId: ObjectData?.nationalId,
                    decisionNumber: ObjectData?.decisionNumber,
                    requestNumber: ObjectData?.request?.id,
                }),
                handlePrintModel, true, "can't-manualy")
        },
        {
            Header: "decisionId",
            accessor: "decisionNumber",
        },
        {
            Header: "patientName",
            accessor: "patientName",

        },
        {
            Header: "phoneNumber",
            accessor: "phoneNumber",
        },
        {
            Header: "nationalId",
            accessor: "nationalId",
        },
        {
            Header: "hospitalName",
            accessor: "hospital",
        },
        {
            Header: "isEligibleForDelivery",
            Cell: ({ row: { original } }: Original) => {
                return <Status cellContent={original?.request?.isEligibleForDelivery.toString()} cellColorMap={BOOLEAN_COLOR_MAP} />
            }
        },
        {
            Header: "daysFromLastDispense",
            accessor: "daysFromLastDispense",
        },
        {
            Header: "diagnosis",
            accessor: "diagnosis",
        },

        {
            Header: "decisionTypeCol",
            accessor: "decisionType",
            Cell: ({ row: { original } }: Original) => {
                return <Status cellContent={original?.decisionTypeId} cellColorMap={STATUS_COLOR_MAP} >
                    {t(original?.decisionType)}
                </Status>
            }
        },

        {
            Header: "decisionPeriod",
            Cell: ({ row: { original } }: Original) => {
                return original?.decisionTypeId === DecisionTypes.Normal ? (
                    <>
                        {dateFormatter(original?.decisionStartDate, "ar", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })}
                        ⬅️
                        {dateFormatter(original?.decisionEndDate, "ar", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })}
                    </>
                ) : (
                    "-"
                );
            }
        },
        {
            Header: "monthNumber",
            Cell: ({ row: { original } }: Original) => original?.decisionTypeId === DecisionTypes.Normal ? getMonthNumber(original?.decisionStartDate) : "-"
        },
        {
            Header: "status",
            accessor: "request.status",
        },
        {
            Header: "serviceType",
            accessor: "serviceType",
        },
        {
            Header: "requestDueDate",
            accessor: "request.deliveryDate",
            Cell: ({ row: { original } }: Original) => <> {handleDate(original?.request?.deliveryDate)}</>
        },
        {
            Header: "lastDeliveryDate",
            Cell: ({ row: { original } }: Original) => (dateFormatter(original.lastDeliveryDate, "en")),
        },
        {
            Header: "textKeyword",
            accessor: "textKeyword",
            canSearch: true,
            visible: false
        },
        {
            Header: "keyword",
            accessor: "keyword",
            canSearch: true,
            visible: false
        },
        {
            Header: "createdDate",
            accessor: "createdDate",
            canSearch: true,
            type: "Date",
            isMulti: true,
            visible: false
        },
        {
            Header: "actions",
            Cell: ({ row: { original } }: any) => {
                return (
                    <>
                        {/* <BaseBtn
                            label="printRequest"
                            icon={"material-symbols:print-rounded"}
                            className='update'
                            ApplyAction={() => handlePrintModel(original.id)}
                            isVisible={original?.isPendingRequest}
                        /> */}
                        <BaseBtn
                            label="BatchDispensePopupBtn"
                            icon={"jam:inboxes-f"}
                            className='update'
                            ApplyAction={() => {
                                setRequestIdToViewBatches(original?.request.id)
                                batchDispensePopupRef?.current?.click()
                            }}
                            isVisible={!original?.request?.isPendingRequest}
                        />
                    </>
                )
            }
        }
    ], [selectedPrintRequestId, state])

    const handlePrintModel = (id: number, isModel: boolean) => {
        setIsModel56(isModel)
        setSelectedPrintRequestId(id)
    }

    useEffect(() => {
        if (!(printRequestMedicines.current && printRequestIsNeedCoolingMedicines.current && requestRow && selectedPrintRequestId)) return
        handlePrint([printRequestMedicines, printRequestIsNeedCoolingMedicines]);
        setSelectedPrintRequestId(null);
        setData(null)

    }, [handlePrint, requestRow, selectedPrintRequestId]);

    const ShowAccordion = (id: number, hopsitalId: number, remAmount: number, monAmount: number, decisionId: number, patientData: PatientData) => {


        if (!checkIfSelectedPharmacy(state)) return errorToaster("please-select-hosptial")

        setRemainingAmount(remAmount)
        setMothlyAmount(monAmount)
        setDecisionId(decisionId)
        modelpopup.current.click()
        setRecordID(id)
        setHospitalID(hopsitalId)
        setPatientData({
            name: patientData?.name,
            nationalId: patientData?.nationalId,
            decisionNumber: patientData?.decisionNumber,
            requestNumber: patientData?.requestNumber,
        })
    }
    return (
        <>
            <BatchDispensePopup
                modalId={batchDispensePopupRef}
                recordId={requestIdToViewBatches}
                handlePrint={() => setSelectedPrintRequestId(requestIdToViewBatches)}
            />

            <PrintContentWrapper printRef={printRequestMedicines} className="request-print-width" >
                <PrintableRequestTable data={requestRow} />
            </PrintContentWrapper >

            <PrintContentWrapper printRef={printRequestIsNeedCoolingMedicines} className="request-print-width" >
                <PrintableRequestTable data={requestRow} isNeedCooling />
            </PrintContentWrapper>
            <MedicinesPopup remainingAmount={remainingAmount} mothlyAmount={mothlyAmount} hospitalId={hospitalID} recordID={recordID} modalID={modelpopup} decisionId={decisionId} patientData={patientData} />

            <ReportsPagesContent needParams tableAPI={(keyword: any) => GetDecisionsForManualReceive(keyword,
                !!!Number(sessionStorage.getItem("hopsitalId")) ? null : Number(sessionStorage.getItem("hopsitalId")))} columns={columns} >
                <SearchWrapper haveCustomPriority>
                    <div className="alert">
                        {t('please-search')}
                    </div>
                </SearchWrapper>
            </ReportsPagesContent >
        </>
    )
}

export default ManualReceive